/**
 * Bonus content row.
 */
import React from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";

import { VText, VButton } from "form";
import { BThumb } from "components";

/**
 * Bonus unit row with a link into the player.
 *
 * @param {{ item: Object }} props
 */
const CourseBonusItem = (props) => {
  const { item } = props;

  return (
    <Box className={`border border-solid border-2 rounded-md relative border-gray-200 dark:border-gray-500`}>
      <a href={item.href} download target="_blank" rel="noreferrer">
        <VButton className="absolute top-2 right-2" iconOnly>
          <Icon icon="eva:download-fill" />
        </VButton>
      </a>
      <Box className="flex flex-col w-full">
        <BThumb src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/bonus1.png`} error="" className="w-full aspect-[5/3] rounded" />
      </Box>
      <Box className="p-4 flex flex-col gap-1">
        <VText className="flex items-center">
          <Icon icon="gala:file-doc" className="text-gray-700 flex-shrink-0" />
          &nbsp;{item.display_name}
        </VText>
        <VText className="text-sm" color="secondary">
          {item.type}
        </VText>
      </Box>
    </Box>
  );
};

export default CourseBonusItem;
